import { render, staticRenderFns } from "./Home-company.vue?vue&type=template&id=bd7f9274"
import script from "./Home-company.vue?vue&type=script&lang=js"
export * from "./Home-company.vue?vue&type=script&lang=js"
import style0 from "./Home-company.vue?vue&type=style&index=0&id=bd7f9274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports